"use client";
import { Button } from "@/components/ui/button";
import RouterLink from "@/components/ui/router-link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { getLocale } from "@/lib/getSite";
import { useCallback } from "react";
import NotFoundImage from "./404-page-not-found.svg";

const cnLangData: Record<string, string> = {
  "404": "404",
  "这里什么也没有": "这里什么也没有",
  "POWERQUARK": "POWERQUARK",
  "POWERQUARK · 为效率而生": "POWERQUARK · 为效率而生",
  "抱歉,您访问的页面不存在": "抱歉,您访问的页面不存在",
  "返回首页": "返回首页"
};

const enLangData: Record<string, string> = {
  "404": "404",
  "这里什么也没有": "There's nothing here",
  "POWERQUARK": "POWERQUARK",
  "POWERQUARK · 为效率而生": "POWERQUARK · Born for Efficiency",
  "抱歉,您访问的页面不存在": "Sorry, the page you are looking for does not exist",
  "返回首页": "Return to Homepage"
};

export default function NotFound() {
  const pathname = usePathname();

  const locale = getLocale(pathname);

  const t = useCallback((code: string) => {
    switch (locale) {
      case "cn": return cnLangData[code];
      case "en": return enLangData[code];
      default: return ""
    }
  }, [locale])

  return (
    <div className="flex h-screen w-screen bg-white">
      <div className="content_container h-full w-full">
        <div className="flex h-full flex-col items-center pt-20">
          <div className="relative flex w-full justify-center">
            <Image src="/404.webp" alt="404" width={103} height={87} />
            <div className="absolute -bottom-9 left-0 right-0 w-full text-center text-xl text-[#E5E5E5]">
              <p>{t("这里什么也没有")}</p>
              <p>...</p>
            </div>
          </div>

          <div className="pt-16">
            <Image
              src={NotFoundImage}
              alt="Not Found"
              width={248}
              height={185}
            />

            <h1 className="pt-5 text-center text-lg text-[#2C2C2C]">
              {t("SOUTHCHIP")}
            </h1>

            <h2 className="pt-2 text-center text-sm text-[#464665]">
              {t("POWERQUARK · 为效率而生")}
            </h2>
          </div>

          <div className="flex justify-center pt-24">
            <RouterLink href="/">
              <Button className="h-11 w-40 rounded-full bg-[#383838] text-sm text-white shadow-lg">
                {t("返回首页")}
              </Button>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  );
}
